import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuthLayoutComponent } from '@app/app-layout/auth-n/layout/auth-layout.component';
import { ResetPasswordFormComponent } from '@auth-n/reset-password/reset-password-form.component';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AuthLayoutComponent, ResetPasswordFormComponent]
})
export class ResetPasswordComponent {}
